// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"75":"8b8d5fb5","77":"7de6efce","163":"0c56ecbd","336":"f4d15344","374":"45c8a52f","932":"f49227b5"}[chunkId] + ".chunk.css";
};